<template>
  <div class="row account-edit">
    <div class="col col-xl-8 col-12">
      <InformationOrganization />
    </div>
    <div class="col col-xl-4 col-12">
      <Socials />
    </div>
  </div>
</template>

<script>
import InformationOrganization from './panels/InformationOrganization';
import Socials from './panels/Socials';

export default {
  name: 'AccountEditOrganization',
  components: { InformationOrganization, Socials },
};
</script>
